export enum ComputerAuthorizationModalMode {
  Create = 'create',
  Edit = 'edit'
}
